import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TransactionsService } from '../../services/transactions.service';
import { ProofService } from '../../services/proof.service';
import { ConnectionService } from '../../services/connection.service';
import { PendingEvidenceViewerDialogService } from './pending-evidence-viewer.service.dialog';
import { Transaction } from '@contracts/interfaces/transaction.interfaces';

export interface DialogData {
  pendingEvidence: any;
  pendingEvidenceList: any[];
  index: number;
}

@Component({
  selector: 'ap-pending-evidence-viewer-dialog',
  templateUrl: 'pending-evidence-viewer.dialog.html',
  styleUrls: ['./pending-evidence-viewer.dialog.scss']
})
export class PendingEvidenceViewerDialogComponent {

  public src: string;
  public type: string;
  public pendingEvidence: any;
  public pendingEvidenceList: any[];
  public index: number;

  public existingTransactions: Transaction[] = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    public dialogRef: MatDialogRef<PendingEvidenceViewerDialogComponent>,
    public pendingEvidenceViewerDialogService: PendingEvidenceViewerDialogService,
    public transactionService: TransactionsService,
    public proofService: ProofService,
    private connectionService: ConnectionService) { }

  ngOnInit() {

    this.pendingEvidenceList = this.data.pendingEvidenceList;
    this.index = this.data.index;

    this.viewPendingEvidence(this.pendingEvidenceList[this.index]);
  }

  next() {
    this.save(false);

    this.index++;

    if (this.pendingEvidenceList[this.index] == undefined) {
      this.dialogRef.close();
    } else {
      this.viewPendingEvidence(this.pendingEvidenceList[this.index]);
    }
  }

  prev() {
    this.save(false);

    this.index--;

    if (this.pendingEvidenceList[this.index] == undefined) {
      this.dialogRef.close();
    } else {
      this.viewPendingEvidence(this.pendingEvidenceList[this.index]);
    }
  }

  saveAndClose() {
    this.save(true);
  }

  save(close=false) {
    this.proofService.updatePendingEvidence(this.pendingEvidence).subscribe(r=> {
      if (close) {
        this.pendingEvidenceViewerDialogService.dialog.closeAll();
      }
    })
  }

  viewPendingEvidence(pendingEvidence: any) {
    this.proofService.doesEvidenceAlreadyExist(pendingEvidence).subscribe((result: Transaction[] | null) => {
      if (result !== null) {
       this.existingTransactions = result;
      } else {
        this.existingTransactions = [];
      }
    })

    this.proofService.loadPendingEvidence(pendingEvidence).subscribe(type => {

      if (type == "application/pdf") {
        this.type = "pdf";
      } else {
        this.type = "image";
      }

      this.src = this.connectionService.address + "/evidence-service/view-pending-evidence?filename="+pendingEvidence.file;
    });

    if (pendingEvidence.business == undefined) {
      pendingEvidence.business = "";
    }

    if (pendingEvidence.amount == undefined) {
      pendingEvidence.amount = 0;
    }

    if (pendingEvidence.note == undefined) {
      pendingEvidence.note = '';
    }

    this.pendingEvidence = pendingEvidence;
  }

  deletePendingEvidence() {
    this.proofService.deletePendingEvidence(this.pendingEvidence).subscribe(r => {
      this.next();
    });
  }
}
